import { AgGridReact } from 'ag-grid-react';
import { colors, styled } from '../theme';

export const Text = styled.span`
  font-family: 'Lato';
  font-size: 0.8rem;
  color: ${({ theme }) => theme.core.textColor};
`;

export const LabeledText = styled(Text)<{fontColor?: string}>`
  opacity: 0.7;
  color: ${({ theme, fontColor }) => (fontColor || theme.core.textColor)};
`;

export const NormalText = styled(Text)``;

export const StrongText = styled(Text)`
  font-size: 1rem;
`;

export const DataContainer = styled.div`

`;

export const TftfTable = styled.table`
  width: 100%;
  td {
    padding: 5px;
  }
`

export const TftfTableHead = styled.thead`
  border-bottom: 2px solid ${({ theme }) => theme.core.alternateBackground};
  margin-bottom: 1em;
  th {
    text-decoration: underline;
  }
  font-family: Lato;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const TftfTableBody = styled.tbody`
  font-family: Lato;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  > :nth-child(2n) {
    background: ${({ theme }) => theme.core.alternateBackground};
  }
`

export const LitField = styled.span<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor };
  padding: 2px 10px 2px 10px;
`

export const ButtonBase = styled.button`
	line-height: 3em;
	border-radius: 3px;
	width: 75px;
`;

export const CloseButton = styled(ButtonBase)`
  background-color: ${colors.accents.bad.base};
`;

export const AddButton = styled(ButtonBase)`
	background-color: ${colors.accents.dominant.base};

	&:disabled {
		opacity: 0.2
	}
`;

export const RemoveButton = styled(ButtonBase)`
	background-color: ${colors.accents.bad.base};

	&:disabled {
		opacity: 0.2
	}
`;

export const StyledAgGridReact = styled(AgGridReact)`
  flex: 1;
  height: calc(100% - 40px);
  width: 100%;
`;

export const TftfSelect = styled.div`
  width: 100%;
  .react-select__control {
    background-color: initial;
  }
  .react-select__control, .react-select__single-value, .react-select__menu {
    color: ${({ theme }) => theme.core.textColor} !important;
  }
  .react-select__option--is-focused {
    background-color: ${({ theme }) => theme.core.alternateBackground};
  }
  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.core.alternateChartBackground};
  }
  .react-select__menu {
    background-color: ${({ theme }) => theme.core.darkBackground};
    z-index: 1000
  }
`;
